import { createTheme } from "@mui/material/styles";
import { ukUA } from "@mui/material/locale";

// ClearFlow-палітра для залишкових MUI-контролів (діалоги/форми) — щоб вони не були
// зеленими (старий бренд), а збігалися з @dms/ui: Deep Blue / Flow Teal + статусні
// кольори дизайн-системи. MUI поступово прибираємо (Phase 4); поки лишається — синій.
export const theme = createTheme(
  {
    palette: {
      primary: { main: "#18488f" }, // --blue-500 (ClearFlow brand primary)
      secondary: { main: "#1890a8" }, // --teal-500 (ClearFlow brand secondary)
      success: { main: "#1e8a5b" }, // --green-500
      warning: { main: "#c77a0a" }, // --amber-500
      error: { main: "#c8453b" }, // --red-500
      info: { main: "#1a73b8" }, // --infoblue-500
      background: { default: "#f4f6f9" }, // --neutral-50
    },
    typography: {
      fontFamily:
        '"Inter", system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
    },
    shape: { borderRadius: 8 }, // --radius-md
    spacing: 8,
  },
  ukUA, // MUI Ukrainian locale (ISO uk-UA), NFR-LOC-001
);

export const PRODUCT_NAME = "Bukovel-Документообіг";
